import { Link } from "react-router-dom";

function FoldersTable({ title, items }) {
  const tableStyle = { width: "100%", borderCollapse: "collapse" };
  const headerCellStyle = { border: "1px solid #ddd", padding: "10px", fontWeight: 600, background: "#f9f9f9" };
  const cellStyle = { border: "1px solid #ddd", padding: "10px" };
  const indexCellStyle = { ...cellStyle, textAlign: "center", width: "80px" };

  return (
    <div className="tp-service-3-area pt-80 pb-50">
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <div className="tp-service-title-box text-center mb-70">
              <span className="tp-section-subtitle">
                Documentos para el trabajo municipal
              </span>
              <h4 className="tp-section-title">{title}</h4>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <style>
              {`
                .folders-table tbody tr {
                  transition: background-color 0.2s ease;
                }
                .folders-table tbody tr:hover {
                  background-color: #f0f7ff;
                }
                .folders-table tbody tr:hover a {
                  color: #0066cc !important;
                }
              `}
            </style>
            <table style={tableStyle} className="folders-table">
              <thead>
                <tr>
                  <th style={{ ...headerCellStyle, width: "80px", textAlign: "center" }}>Item</th>
                  <th style={headerCellStyle}>Carpeta</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr key={index}>
                    <td style={indexCellStyle}>{index + 1}</td>
                    <td style={cellStyle}>
                      <Link 
                        to={item.path} 
                        style={{ 
                          textDecoration: 'none', 
                          color: '#333',
                          fontWeight: 500,
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          transition: 'color 0.2s ease'
                        }}
                      >
                        {item.title}
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FoldersTable;

